import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { useAbility } from 'providers/casl'
import { pageForGeneralFormFromDTO } from './api/mapper'
import { GET_PAGE } from './api/query'
import { PageForGeneralForm, UseGetPage, UseGetPageProps } from './types'

export const useGetPage = ({ id }: UseGetPageProps): UseGetPage => {
  const ability = useAbility()
  const [page, setPage] = useState<PageForGeneralForm>()

  const { loading } = useQuery(GET_PAGE(ability), {
    onCompleted: ({ node: page }) => {
      if (page) {
        setPage(pageForGeneralFormFromDTO(page))
      }
    },
    skip: !id,
    variables: { id: id! },
  })

  return { loading, page }
}
